import React, {
  FC,
} from 'react';
import { ColumnCenter } from './Styles';
import SquadRegularText from '../../../../../components/Text/SquadRegularText';
import PingFangSemiBoldText from '../../../../../components/Text/PingFangSemiBoldText';
import PingFangRegularText from '../../../../../components/Text/PingFangRegularText';
import SquadExtraBoldText from '../../../../../components/Text/SquadExtraBoldText';
import CabBoxOpenedImage from '../../../../../components/CabBoxOpenedImage/User';
import SquadSemiBoldItalicText from '../../../../../components/Text/SquadSemiBoldItalicText';
import RowCenter from '../../../../../components/Layout/RowCenter';

const OpenedBox: FC<Props> = ({
  style,
  width,
  isEnglish,
  cabSizeType,
  lockAddress,
  lockPort,
  boxNumber,
}) => {
  return (
    <div style={{ width, ...style }}>
      <RowCenter>
        <ColumnCenter style={{ width: 203, marginRight: 10 }}>
          {
            isEnglish ? (
              <SquadSemiBoldItalicText fontSize={20} lineHeight={25} textAlign={'center'}>
                <SquadRegularText fontSize={16} lineHeight={24}>Cubicle has opened in the </SquadRegularText>
                <br />
                {cabSizeType === 'large' ? 'Large' : 'Regular'} Locker:
              </SquadSemiBoldItalicText>
            ) : (
              <PingFangSemiBoldText fontSize={16} lineHeight={25} textAlign={'center'}>
                {cabSizeType === 'large' ? '加大尺寸智能柜' : '普通尺寸智能柜'}
                <PingFangRegularText fontSize={16} lineHeight={25}>柜门<br />已打开： </PingFangRegularText>
              </PingFangSemiBoldText>
            )
          }
          <SquadExtraBoldText fontSize={40} color={'#00B595'} marginTop={15}>
            #{Number(boxNumber) < 10 ? '0' + boxNumber : boxNumber}
          </SquadExtraBoldText>
          {
            isEnglish ? (
              <SquadRegularText fontSize={12} lineHeight={15} textAlign={'center'} marginTop={10}>
                Located the {cabSizeType === 'large' ? 'Large' : 'Regular'} Locker and collect your order from the open cubicle.
              </SquadRegularText>
            ) : (
              <PingFangRegularText fontSize={12} lineHeight={15} textAlign={'center'} marginTop={10}>
                请找到当前柜门并从打开的柜门中取走您的订单。
              </PingFangRegularText>
            )
          }
        </ColumnCenter>

        {/* 柜门打开示意图 */}
        <ColumnCenter style={{ paddingTop: 15, paddingBottom: 15 }}>
          <CabBoxOpenedImage
            cabSizeType={cabSizeType}
            lockAddress={lockAddress}
            lockPort={lockPort}
            width={101}
          />
        </ColumnCenter>
      </RowCenter>
    </div>
  );
};

export interface Props {
  style?: React.CSSProperties;
  width: number;
  isEnglish: boolean;
  cabSizeType: string;
  lockAddress: number;
  lockPort: number;
  boxNumber: string;
}

export default OpenedBox;
